import { SET_ADS } from "../actions/advertisement";

const initialState = {
  ads: [],
  loaded: false,
};

export default function advertisementReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ADS:
      return { ...state, ads: action.payload, loaded: true };
    default:
      return state;
  }
}
